var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDdArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mini btn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mines-iPhone-X-v3",
    transform: "translate(-114.000000, -703.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-header",
    transform: "translate(16.000000, 693.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game-name",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mini-btn",
    transform: "translate(98.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89139428,2.13863367 L2.86147609,-0.891229164 C2.79139778,-0.961362828 2.69784933,-1 2.59810121,-1 C2.4983531,-1 2.40480464,-0.961362828 2.33472633,-0.891229164 L2.1115939,-0.668152081 C1.96640005,-0.522792175 1.96640005,-0.286540813 2.1115939,-0.141402323 L4.65589043,2.40289421 L2.10877084,4.95001381 C2.03869253,5.02014748 2,5.11364058 2,5.21333334 C2,5.31313681 2.03869253,5.40662991 2.10877084,5.47681892 L2.33190327,5.69984065 C2.40203694,5.76997432 2.49553004,5.80861149 2.59527815,5.80861149 C2.69502627,5.80861149 2.78857472,5.76997432 2.85865303,5.69984065 L5.89139428,2.66721011 C5.96163865,2.59685503 6.00022047,2.5029191 6,2.40306028 C6.00022047,2.30281397 5.96163865,2.2089334 5.89139428,2.13863367 Z",
    id: "Path",
    transform: "translate(4.000000, 2.404306) rotate(-270.000000) translate(-4.000000, -2.404306) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDdArrow);
export default __webpack_public_path__ + "static/media/icon-dd-arrow.b7a6222faa299edede9275e8a24ccc9f.svg";
export { ForwardRef as ReactComponent };